import { render } from "./NavigationBottomComponent.vue?vue&type=template&id=742fefe2&scoped=true"
import script from "./NavigationBottomComponent.vue?vue&type=script&lang=js"
export * from "./NavigationBottomComponent.vue?vue&type=script&lang=js"

import "./NavigationBottomComponent.vue?vue&type=style&index=0&id=742fefe2&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742fefe2"]])

export default __exports__